// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BusinessResponse

import { BillingSanctionLevel } from './enums.gen';
import { hydrateWidget, type Widget, type WidgetApiResponse } from './widget.gen';
import { hydrateUser, type User, type UserApiResponse } from './user.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type BusinessApiResponse = {
	id: string;
	name: string;
	logo: string;
	address: string;
	country: string;
	website: string | null;
	googleReviewsUrl: string | null;
	timezone: string;
	fontFamily: string | null;
	registrationDate: string;
	widgets: WidgetApiResponse[];
	contractIsActive: boolean;
	sanctionLevel: BillingSanctionLevel;
	billingEmails: Array<string>;
	isStripeLegacyIndirect: boolean;
	isSplitPaymentEnabled: boolean;
	splitPaymentThreshold: number;
	splitPaymentDelay: number;
	splitPaymentOwnerFee: number;
	splitPaymentFee: number;
	owner: UserApiResponse;
	defaultOfferCollectionId: string;
	package: string;
};

export type Business = {
	id: string;
	name: string;
	logo: string;
	address: string;
	country: string;
	website: string | null;
	googleReviewsUrl: string | null;
	timezone: string;
	fontFamily: string | null;
	registrationDate: DateTime;
	widgets: Widget[];
	contractIsActive: boolean;
	sanctionLevel: BillingSanctionLevel;
	billingEmails: Array<string>;
	isStripeLegacyIndirect: boolean;
	isSplitPaymentEnabled: boolean;
	splitPaymentThreshold: number;
	splitPaymentDelay: number;
	splitPaymentOwnerFee: number;
	splitPaymentFee: number;
	owner: User;
	defaultOfferCollectionId: string;
	package: string;
};

export function hydrateBusiness(data: BusinessApiResponse): Business {
	return {
		...data,
		registrationDate: DateTimefromISO(data.registrationDate)!,
		widgets: data.widgets.map(hydrateWidget),
		owner: hydrateUser(data.owner),
	};
}